import Logo from 'gatsby-theme-header/src/components/header/logo';
import styled from 'styled-components';

export default styled(Logo)`
  max-height: 2.375rem;
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    max-height: 4.0625rem;
  }
`;
